import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const SettingsManager = ({ events }) => {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  useEffect(() => { api.get("/settings").then((r) => setForm({ ...r.data, book_now_texts_str: (r.data.book_now_texts || []).join(", ") })); }, []);

  const save = async () => {
    setSaving(true);
    const texts = form.book_now_texts_str.split(",").map((t) => t.trim()).filter(Boolean);
    try {
      await api.put("/admin/settings", {
        home_title: form.home_title,
        book_now_event_id: form.book_now_event_id || "",
        book_now_texts: texts.length ? texts : ["BOOK NOW"],
      });
      toast.success("Settings saved");
    } catch { toast.error("Save failed"); }
    setSaving(false);
  };

  if (!form) return <Loader2 className="animate-spin text-[#D4AF37]" />;

  return (
    <div className="max-w-2xl" data-testid="settings-manager">
      <div className="card-dark space-y-5 p-6 sm:p-8">
        <div>
          <label className="caption mb-2 block">Homepage Title</label>
          <input className="input-field" value={form.home_title} onChange={(e) => set("home_title", e.target.value)} data-testid="setting-home-title" />
          <p className="mt-1 text-xs text-zinc-500">Shown as the main tagline on the homepage.</p>
        </div>
        <div>
          <label className="caption mb-2 block">BOOK NOW Banner — Linked Event</label>
          <select className="input-field" value={form.book_now_event_id || ""} onChange={(e) => set("book_now_event_id", e.target.value)} data-testid="setting-booknow-event">
            <option value="">Go to all events</option>
            {events.filter((e) => e.status !== "past").map((e) => <option key={e.id} value={e.id}>{e.name}</option>)}
          </select>
        </div>
        <div>
          <label className="caption mb-2 block">BOOK NOW Rotating Texts</label>
          <input className="input-field" value={form.book_now_texts_str} onChange={(e) => set("book_now_texts_str", e.target.value)} placeholder="BOOK NOW, LIMITED TIME, DON'T MISS OUT" data-testid="setting-booknow-texts" />
          <p className="mt-1 text-xs text-zinc-500">Comma-separated. These rotate on the floating button.</p>
        </div>
        <button onClick={save} disabled={saving} className="btn-gold" data-testid="settings-save-button">{saving ? "Saving..." : "SAVE SETTINGS"}</button>
      </div>
    </div>
  );
};
